import ScrollLocker from "./ScrollLocker";
import Cookies from 'js-cookie';
import gsap from "gsap";


export default class ModalController {
    constructor() {
        this.popupWrapper = document.querySelector('.js-modal-wrapper');
        this.closeButton = document.querySelector('.js-close-button');
        this.keepBrowsing = document.querySelector('.js-keep-browsing');

        // this.scrollLock = new ScrollLocker();

        if (this.popupWrapper && !Cookies.get('newsLetterSeen')) {
            this.init();
        }
    }

    init() {

        this.closeButton.addEventListener('click', () => {
            this.hideModal();
        });

        this.wpcf7Elm = document.querySelector( '.js-modal-wrapper .wpcf7' );
        this.wpcf7Elm.addEventListener( 'wpcf7mailsent', function( event ) {
            document.querySelector('.c-modal__newsletter').style.display = "none";
            document.querySelector('.c-modal__subscribed').style.display = "block";
        }, false );

        this.keepBrowsing.addEventListener('click', () => {
            this.hideModal();
        });

    }

    showPopup() {
        gsap.to(this.popupWrapper, .3, {
            delay: 7,
            autoAlpha: 1,
            onComplete: () => {
                // this.scrollLock.lockScroll();
            }
        });
    }

    hideModal() {
        Cookies.set('newsLetterSeen', true, {
            expires: 365
        });

        gsap.to(this.popupWrapper, .3, {
            autoAlpha: 0
        });
        // this.scrollLock.unlockScroll();
    }

}
